import type {RefObject} from 'react';

export function getRefElement<T>(ref: RefObject<T>): T {
    if (ref.current !== null) {
        return ref.current;
    }
    throw new Error('ref is null');
}

export function getRefParent(ref: RefObject<HTMLElement>): HTMLElement {
    const refElement = getRefElement(ref);
    if (typeof refElement.parentElement !== 'undefined' && refElement.parentElement !== null) {
        return refElement.parentElement;
    }
    throw new Error("ref parent doesn't exist");
}
